module.exports = __webpack_public_path__ + "img/intro4-1.7445fb06.png";